module.exports = __webpack_public_path__ + "assets/img/sungrow-inverter.985ffb8a.png";